/* globals Vue */

// Componentes específicos de Call Center
import CallIndex from "./CallIndex.vue";

const callApp = new Vue({
  el: "#call-app",
  components: {
    CallIndex,
  },
});

window.callApp = callApp;